// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__goN2b","row":"styles_row__3SR19"};